var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrgan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 112,
    viewBox: "0 0 118 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60214 56.3721C6.72123 52.0942 9.87243 52.7506 10.9449 53.9526C12.0186 55.1526 12.5832 52.7562 12.5832 52.7562C12.5832 52.7562 10.5374 49.6459 14.1108 48.5118C17.6855 47.3756 15.148 54.6552 15.148 54.6552C15.148 54.6552 16.4804 57.4642 18.3088 57.357C19.3264 57.2969 19.2203 56.5584 18.9263 55.9138C18.637 55.28 18.8733 54.5396 19.4781 54.2061C20.7105 53.5281 22.4909 52.9507 22.4346 55.3087L20.5868 59.228L19.1688 62.2325C19.1603 62.2141 19.1518 62.1958 19.1445 62.1753L19.1015 62.1316C19.1015 62.1316 10.043 67.3893 7.6601 62.5221C7.6601 62.5221 6.41303 61.8021 9.68879 60.2047C12.9645 58.6073 6.48422 60.648 6.60214 56.3721Z",
    fill: "#FAF5E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4345 55.3085C22.4325 55.3451 22.4325 55.3829 22.4305 55.4195C24.5944 58.9919 27.1344 58.683 28.6025 58.4433C28.9171 58.3902 29.2487 58.4683 29.4884 58.6633L27.7964 62.4783C27.7586 62.416 27.7241 62.3529 27.6886 62.2866C27.6886 62.2866 23.1445 64.9082 20.7371 59.2984L20.5867 59.2278L22.4345 55.3085Z",
    fill: "#FAF5E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1687 62.2325L20.5867 59.2279L20.737 59.2985C23.1444 64.9083 27.6886 62.2867 27.6886 62.2867C27.724 62.353 27.7586 62.4161 27.7963 62.4784L26.2894 65.8687C26.2695 65.8276 26.2487 65.7832 26.23 65.74C26.23 65.74 21.5051 67.9037 19.1687 62.2325Z",
    fill: "#FAF5E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7965 62.4781L29.4885 58.6632C29.5906 58.7464 29.6758 58.8496 29.7367 58.9711C31.8183 63.2298 36.0532 63.4327 37.6679 62.9485L36.0369 66.5585C35.9617 66.4098 35.8879 66.2539 35.8164 66.0939C35.8164 66.0939 30.8114 67.8774 27.7965 62.4781Z",
    fill: "#FAF5E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2897 65.8687L27.7966 62.4783C30.8115 67.8776 35.8164 66.0941 35.8164 66.0941C35.8879 66.2541 35.9617 66.41 36.037 66.5587L34.5119 69.9331C34.4656 69.8336 34.4194 69.734 34.3755 69.6304C34.3755 69.6304 28.744 71.2411 26.2897 65.8687Z",
    fill: "#FAF5E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0367 66.5589L37.6677 62.9488L37.7581 62.92C39.535 67.1297 43.4287 67.0061 45.1587 66.6532C45.4803 66.5879 45.8117 66.6524 46.0487 66.8378L44.5347 70.1836C44.5119 70.1191 44.4913 70.0506 44.4708 69.9821C44.4708 69.9821 38.9718 72.3896 36.0367 66.5589Z",
    fill: "#FAF5E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5118 69.9331L36.0368 66.5587C38.9719 72.3894 44.4709 69.9819 44.4709 69.9819C44.4915 70.0504 44.512 70.1189 44.5348 70.1834L42.8874 73.8217C42.8751 73.7769 42.8628 73.732 42.8537 73.6863C42.8537 73.6863 37.1402 75.5194 34.5118 69.9331Z",
    fill: "#FAF5E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5348 70.1834L46.0487 66.8377C46.1713 66.9327 46.2708 67.063 46.3285 67.2231C47.8138 71.3373 51.9032 71.2295 53.5832 70.9773C53.8548 70.9371 54.0783 71.0041 54.2538 71.154L52.715 74.4719C52.6969 74.4183 52.6767 74.3634 52.6585 74.3098C52.6585 74.3098 46.5455 76.4519 44.5348 70.1834Z",
    fill: "#FAF5E1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8872 73.8218L44.5346 70.1834C46.5454 76.4519 52.6584 74.3098 52.6584 74.3098C52.6765 74.3634 52.6967 74.4183 52.7149 74.4719L51.0281 78.1172C51.0172 78.0839 51.0055 78.0475 50.9926 78.0131C50.9926 78.0131 44.233 79.1991 42.8872 73.8218Z",
    fill: "#FAF5E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7148 74.4718L54.2536 71.1539C54.3718 71.2518 54.4679 71.3882 54.5455 71.5517C56.6556 76.0401 60.3713 75.9648 62.0025 75.679C62.2373 75.6364 62.4724 75.6831 62.669 75.7966L61.2464 78.9227C61.2464 78.9227 54.9561 80.5442 52.7148 74.4718Z",
    fill: "#FAF5E1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0283 78.1174L52.7151 74.4721C54.9564 80.5445 61.2467 78.923 61.2467 78.923L59.5567 82.6447C58.5357 82.843 52.9637 83.6462 51.0283 78.1174Z",
    fill: "#FAF5E1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2469 78.9228L62.6695 75.7968C62.864 75.9091 63.0223 76.0841 63.1181 76.3013C64.8873 80.3257 68.9936 80.2736 70.6605 80.0678C70.8775 80.0419 71.0927 80.0852 71.2773 80.1864L69.6953 83.6548C68.2812 84.066 63.2391 85.0483 61.2469 78.9228Z",
    fill: "#FAF5E1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5566 82.6446L61.2466 78.9229C63.2388 85.0484 68.2809 84.0661 69.695 83.6549L68.3294 86.6492L68.3274 86.648C68.3274 86.648 62.1493 88.5907 59.7168 82.613C59.7168 82.613 59.6601 82.6261 59.5554 82.6466L59.5566 82.6446Z",
    fill: "#FAF5E1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6951 83.6549L71.2772 80.1866C71.4533 80.2882 71.6045 80.4376 71.6997 80.6275C74.3188 85.8469 79.5154 84.6489 80.5343 84.3548C80.5978 84.3348 80.6603 84.3115 80.7191 84.2807L78.9171 88.1347C78.7227 88.1736 71.4937 89.6147 70.0717 83.5324C70.0717 83.5324 69.9366 83.5866 69.6951 83.6549Z",
    fill: "#FAF5E1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2183 91.7675L76.843 91.5616C76.843 91.5616 71.6198 92.7631 68.3307 86.647L69.6963 83.6527C69.9378 83.5844 70.0729 83.5301 70.0729 83.5301C71.4948 89.6124 78.7239 88.1713 78.9183 88.1325L77.2224 91.7698C77.2224 91.7698 77.2183 91.7675 77.2195 91.7655L77.2183 91.7675Z",
    fill: "#FAF5E1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M78.917 88.1345L80.7189 84.2804C80.7625 84.257 80.8051 84.2304 80.8469 84.2006C85.1349 81.0722 84.1447 84.0027 84.1447 84.0027C83.2714 86.4044 85.359 86.1554 85.359 86.1554C89.8021 84.5412 91.312 86.4328 91.6717 87.0533C91.7335 87.1592 91.7737 87.2741 91.7945 87.394C92.532 91.7914 87.4779 90.5814 87.0724 90.6359C86.6648 90.6893 85.8438 91.3782 86.0421 92.2455C86.2395 93.1095 88.6815 93.5993 88.0694 94.4088C87.8175 94.741 87.3861 94.902 86.9656 94.9776C86.3852 95.0796 86.0195 95.6563 86.1763 96.2218C86.9302 98.945 85.6602 98.8323 85.6602 98.8323C80.1723 99.9296 77.6093 92.9484 77.221 91.7718L78.917 88.1345Z",
    fill: "#FAF5E1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0629 98.5339L77.2214 91.7721L78.9173 88.1347L80.7193 84.2807L101.439 39.9041",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2332 93.4359L68.3297 86.6491L69.6953 83.6548L71.2774 80.1864L87.3695 44.9179L92.0478 34.6679L92.1141 34.52",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.662 89.0109L56.7125 88.8997L56.8386 88.6245L59.5568 82.6445L61.2468 78.9228L62.6694 75.7968L75.5601 47.4352L78.437 41.1044",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0891 43.4565L67.396 42.7973",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2122 84.1917L51.0285 78.1173L52.7153 74.472L54.2541 71.1541L64.0109 50.1028L67.0889 43.4618",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M40.269 79.6059L42.8876 73.822L44.535 70.1836L46.0489 66.8379L52.6545 52.2424L55.4197 46.1384L55.6135 45.708",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2168 48.4472L44.27 48.3313",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8204 75.8908L34.5119 69.9332L36.037 66.5588L37.668 62.9487L37.7259 62.8202L37.7945 62.6683L41.8934 53.5921L44.2155 48.4492",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8774 71.3049L26.2898 65.8687L27.7967 62.4784L29.4887 58.6634L31.3349 54.5058L33.5177 49.59L33.7723 49.0166",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5915 50.7313L24.2755 51.4015L22.4347 55.3087L20.5869 59.228L19.1689 62.2325L16.8148 67.2274",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0992 34.6924C92.122 34.6435 92.1456 34.5978 92.1713 34.5533C93.0055 33.1084 95.7583 33.1355 98.3159 34.6122C100.873 36.0888 102.273 38.4592 101.439 39.9041C100.605 41.3489 97.8543 41.323 95.2946 39.8452C92.735 38.3674 91.4261 36.1466 92.0992 34.6924Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6057 41.1344C78.6324 40.8233 78.7208 40.5236 78.8774 40.2525C79.7116 38.8076 82.1675 38.6633 84.3606 39.9295C86.5536 41.1957 87.5861 43.2568 86.8946 44.7004C86.8718 44.7493 86.8482 44.795 86.8225 44.8395C85.9871 46.2864 83.5312 46.4307 81.3381 45.1645C79.5566 44.136 78.4938 42.4917 78.6057 41.1344Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M67.089 43.4564C67.1371 43.2549 67.2101 43.0623 67.3141 42.8822C68.1482 41.4373 70.6021 41.2919 72.7952 42.558C74.9883 43.8242 76.0228 45.8866 75.3292 47.329C75.3064 47.3779 75.2828 47.4236 75.2571 47.4681C74.4229 48.9129 71.969 49.0584 69.7739 47.791C67.8573 46.6845 66.7744 44.8667 67.0887 43.4617C67.0899 43.4596 67.091 43.4576 67.089 43.4564Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6136 45.7079C56.4478 44.2631 58.6616 43.7011 60.8547 44.9673C63.0478 46.2335 64.648 48.6305 63.9934 50.0954C63.9706 50.1443 63.947 50.19 63.9213 50.2345C63.0871 51.6794 60.0274 51.4697 57.8323 50.2023C55.8521 49.0591 54.9592 47.494 55.4197 46.1383C55.4679 45.9934 55.533 45.8476 55.6136 45.7079Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M44.217 48.4473C44.2566 48.1896 44.3398 47.9462 44.4706 47.7195C45.3048 46.2747 47.7607 46.1304 49.9538 47.3966C52.1469 48.6628 53.1793 50.7239 52.4879 52.1675C52.4651 52.2164 52.4414 52.2621 52.4157 52.3066C51.5804 53.7535 49.1245 53.8978 46.9314 52.6316C45.0823 51.5641 44.0074 49.8318 44.2159 48.4493L44.217 48.4473Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5178 49.5901C33.5636 49.4115 33.6334 49.2386 33.7268 49.0767C34.561 47.6319 37.0149 47.4864 39.208 48.7526C41.4011 50.0188 42.4355 52.0811 41.742 53.5235C41.7192 53.5724 41.6956 53.6181 41.6699 53.6626C40.8345 55.1095 38.3807 55.255 36.1855 53.9876C34.2382 52.8633 33.1532 51.0066 33.5178 49.5901Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2757 51.4016C24.3015 51.1629 24.3733 50.9345 24.4937 50.7261C25.1888 49.5221 27.2336 49.3994 29.0622 50.4552C30.8908 51.5109 31.7519 53.2303 31.174 54.4346C31.155 54.4722 31.1361 54.5098 31.1139 54.5483C30.4187 55.7523 28.3731 55.8718 26.5445 54.816C25.0333 53.9435 24.144 52.5424 24.2757 51.4016Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0629 98.5337C73.2287 99.9785 70.5762 100.009 68.1394 98.6025C65.7027 97.1956 64.4031 94.8831 65.2373 93.4383",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2373 93.4384C64.4031 94.8832 61.8489 94.9707 59.533 93.6336C57.4464 92.4289 56.2672 90.48 56.6642 89.0499C56.6777 88.9983 56.6931 88.9479 56.7127 88.8998C56.7454 88.8054 56.7874 88.7136 56.8388 88.6246C56.8415 88.6153 56.8473 88.6052 56.852 88.5971",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5995 89.0342C55.7653 90.479 53.2111 90.5666 50.8952 89.2295C48.5792 87.8924 47.3779 85.6366 48.2121 84.1917",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2123 84.1919C47.3781 85.6368 45.2662 85.9797 42.9503 84.6425C40.6343 83.3054 39.4351 81.0508 40.2693 79.606",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2692 79.6059C39.435 81.0508 36.8196 82.2659 34.5036 80.9287C32.1877 79.5916 30.9864 77.3359 31.8206 75.891",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8206 75.891C30.9864 77.3358 28.8745 77.6787 26.5585 76.3416C24.2426 75.0045 23.0433 72.7499 23.8775 71.3051",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8773 71.3048C23.0432 72.7497 20.7859 73.0086 18.8365 71.8831C16.887 70.7576 15.9806 68.6721 16.8148 67.2273",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8432 91.5618C76.8432 91.5618 71.62 92.7633 68.3309 86.6472L68.3288 86.646C68.3288 86.646 62.1508 88.5887 59.7183 82.611C59.7183 82.611 59.6616 82.6241 59.5569 82.6446C58.5359 82.843 52.9639 83.6462 51.0285 78.1173C51.0176 78.0841 51.0059 78.0477 50.993 78.0132C50.993 78.0132 44.2334 79.1992 42.8877 73.822C42.8754 73.7771 42.8631 73.7322 42.854 73.6865C42.854 73.6865 37.1405 75.5196 34.512 69.9333C34.4658 69.8338 34.4195 69.7342 34.3756 69.6306C34.3756 69.6306 28.7441 71.2413 26.2898 65.8688C26.2699 65.8277 26.2491 65.7833 26.2303 65.7401C26.2303 65.7401 21.5055 67.9038 19.1691 62.2326C19.1606 62.2142 19.1521 62.1958 19.1448 62.1754",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9205 88.1339L78.9184 88.1327C78.7228 88.1736 71.4938 89.6147 70.0718 83.5324C70.0718 83.5324 69.9368 83.5866 69.6953 83.6549C68.2811 84.0661 63.2391 85.0485 61.2469 78.9229C61.2469 78.9229 54.9566 80.5445 52.7153 74.4721C52.6971 74.4184 52.6769 74.3636 52.6587 74.3099C52.6587 74.3099 46.5457 76.452 44.535 70.1836C44.5121 70.1191 44.4916 70.0506 44.4711 69.9821C44.4711 69.9821 38.9721 72.3896 36.037 66.5589C35.9618 66.4102 35.888 66.2543 35.8165 66.0943C35.8165 66.0943 30.8115 67.8778 27.7966 62.4785C27.7588 62.4162 27.7243 62.3531 27.6889 62.2868C27.6889 62.2868 23.1447 64.9084 20.7373 59.2986",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1659 91.6077C77.1659 91.6077 77.1829 91.6634 77.2184 91.7675C77.2172 91.7695 77.2181 91.7727 77.2213 91.7719C77.6095 92.9485 80.1725 99.9297 85.6604 98.8324C85.6604 98.8324 86.9305 98.9451 86.1766 96.2218C86.0198 95.6564 86.3855 95.0797 86.9659 94.9777C87.3863 94.9021 87.8178 94.7411 88.0696 94.4089C88.6817 93.5994 86.2397 93.1096 86.0423 92.2455C85.8441 91.3783 86.665 90.6894 87.0726 90.636C87.4782 90.5814 92.5322 91.7915 91.7947 87.3941C91.7739 87.2741 91.7338 87.1592 91.672 87.0534C91.3122 86.4329 89.8024 84.5413 85.3593 86.1555C85.3593 86.1555 83.2716 86.4044 84.1449 84.0027C84.1449 84.0027 85.1351 81.0723 80.8472 84.2006C80.8054 84.2305 80.7627 84.2571 80.7192 84.2805C80.6604 84.3113 80.5978 84.3346 80.5344 84.3546C79.5155 84.6486 74.3189 85.8467 71.6998 80.6273C71.6046 80.4374 71.4545 80.286 71.2772 80.1864C71.0926 80.0852 70.8774 80.0419 70.6604 80.0677C68.9935 80.2736 64.8871 80.3257 63.118 76.3012C63.0222 76.0841 62.8639 75.909 62.6694 75.7967C62.4748 75.6844 62.2377 75.6365 62.0029 75.679C60.3717 75.9649 56.656 76.0402 54.5458 71.5518C54.4682 71.3883 54.3722 71.2519 54.254 71.154C54.0785 71.004 53.855 70.9371 53.5834 70.9772C51.9033 71.2295 47.814 71.3373 46.3287 67.2231C46.271 67.063 46.1715 66.9327 46.0489 66.8376C45.8119 66.6522 45.4805 66.5877 45.1589 66.653C43.4289 67.0059 39.5352 67.1295 37.7583 62.9198M37.7583 62.9198C37.7413 62.8831 37.7305 62.8498 37.7258 62.8201C37.705 62.7191 37.7444 62.6744 37.7944 62.6682C37.9052 62.6512 38.0694 62.8161 37.7583 62.9198ZM37.7583 62.9198L37.668 62.9486C36.0533 63.4329 31.8184 63.23 29.7368 58.9712C29.6758 58.8497 29.5907 58.7466 29.4886 58.6633C29.2489 58.4683 28.9173 58.3902 28.6027 58.4433C27.1346 58.683 24.5946 58.9919 22.4307 55.4195",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1017 62.1315C19.1017 62.1315 10.0432 67.3892 7.66029 62.5221C7.66029 62.5221 6.41322 61.8021 9.68898 60.2047C12.9647 58.6073 6.48441 60.6479 6.60233 56.372C6.72142 52.0941 9.87262 52.7506 10.9451 53.9526C12.0188 55.1526 12.5833 52.7561 12.5833 52.7561C12.5833 52.7561 10.5376 49.6458 14.111 48.5117C17.6856 47.3755 15.1482 54.6551 15.1482 54.6551C15.1482 54.6551 16.4806 57.4642 18.309 57.3569C19.3266 57.2968 19.2205 56.5584 18.9265 55.9138C18.6372 55.2799 18.8735 54.5395 19.4783 54.2061C20.7107 53.5281 22.4911 52.9506 22.4348 55.3086C22.4328 55.3452 22.4328 55.383 22.4308 55.4196",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8721 70.4408L94.3285 63.4327",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8353 70.4058L95.9108 65.7896",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5531 38.4505L51.1483 37.0376",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2352 35.9412L50.1858 34.9115",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5581 88.0181L38.7606 86.295",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M41.856 90.6183L36.3374 87.4322",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgan);
export default __webpack_public_path__ + "static/media/organ.10b7ec07081341e1f8cbd7d0633500b9.svg";
export { ForwardRef as ReactComponent };